import React from "react";
import styles from "./ProgrammeEvents.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Link from "next/link";
import Image from "next/image";
const ProgrammeEvents = ({ data, title }: any) => {
  const sectionTitle = data?.title || title || "Masterclass";
  const sectionDescription =
    data?.description ||
    data?.sub_title ||
    data?.content ||
    data?.rich_text ||
    "";

  const shouldDisplay = data?.hide_section !== true;

  if (!shouldDisplay) {
    return null;
  }

  const slides = Array.isArray(data)
    ? data
    : data?.events ||
      data?.cards ||
      data?.items ||
      data?.list ||
      data?.event_list ||
      [];
  const resolvedSlides = Array.isArray(slides) ? slides : [];
  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const hasMultipleSlides = resolvedSlides.length > 1;

  if (!resolvedSlides.length) {
    return null;
  }

  const settings = {
    dots: hasMultipleSlides,
    infinite: hasMultipleSlides,
    arrows: false,
    speed: 600,
    fade: hasMultipleSlides,
    autoplay: hasMultipleSlides,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    appendDots: (dots: React.ReactNode) => (
      <div className={styles.dotsWrapper}>
        <ul>{dots}</ul>
      </div>
    ),
  };

  const renderEventCard = (event: any, index: number) => {
    const eventHref = event?.url || event?.type_link?.url || event?.link || "#";
    const isClickable = eventHref && eventHref !== "#";
    const badgeLabel =
      event?.type_link?.label ||
      event?.type ||
      event?.text_tag ||
      "Event";
    const cardTitle =
      event?.banner?.description || event?.title || event?.heading || "";
    const cardDescription =
      event?.description || event?.sub_title || event?.summary || "";
    const desktopImage =
      event?.banner?.desktop_img?.url ||
      event?.image?.url ||
      event?.image ||
      "/assets/upcoming_events.png";
    const mobileImage =
      event?.banner?.mobile_img?.url ||
      event?.mobile_image?.url ||
      event?.mobile_image ||
      event?.image?.url ||
      event?.image ||
      desktopImage;

    const formattedDate = formatDate(event?.date);
    
    const badgeContent = isClickable ? (
      <Link
        href={eventHref}
        className={styles.badgeLink}
        aria-label={`${badgeLabel}: ${cardTitle}`}
      >
        <span className={styles.badge}>{badgeLabel}</span>
      </Link>
    ) : (
      <span className={styles.badge}>{badgeLabel}</span>
    );

    return (
      <article key={event?.id || index} className={styles.eventCard}>
        <div className={styles.mediaColumn}>
          <div className={styles.desktopImage}>
            <Image
              src={desktopImage}
              alt={
                event?.banner?.desktop_img?.title ||
                event?.image?.alternativeText ||
                badgeLabel
              }
              title={
                event?.banner?.desktop_img?.title ||
                event?.image?.alternativeText ||
                badgeLabel
              }
              width={600}
              height={420}
              className={styles.image}
            />
          </div>
          <div className={styles.mobileImage}>
            <Image
              src={mobileImage}
              alt={
                event?.banner?.mobile_img?.title ||
                event?.mobile_image?.alternativeText ||
                event?.image?.alternativeText ||
                badgeLabel
              }
              title={
                event?.banner?.mobile_img?.title ||
                event?.mobile_image?.alternativeText ||
                event?.image?.alternativeText ||
                badgeLabel
              }
              width={600}
              height={420}
              className={styles.image}
            />
          </div>
        </div>
        <div className={styles.details}>
          <div className={styles.metaRow}>
            {badgeContent}
            {formattedDate && (
              <span className={styles.date}>{formattedDate}</span>
            )}
          </div>
          {cardTitle && <p className={styles.eventTitle}>{cardTitle}</p>}
          {cardDescription && (
            <p className={styles.eventDescription}>{cardDescription}</p>
          )}
        </div>
      </article>
    );
  };

  return (
    <section className={styles.eventRow}>
      <div className="container">
        <div className={styles.sectionHeader}>
          {sectionTitle && <h2 className={styles.title}>{sectionTitle}</h2>}
          {sectionDescription && (
            <p className={styles.sectionDescription}>{sectionDescription}</p>
          )}
        </div>

        {hasMultipleSlides ? (
          <Slider {...settings} className={styles.slider}>
            {resolvedSlides.map(renderEventCard)}
          </Slider>
        ) : (
          <div className={styles.singleSlide}>
            {resolvedSlides.map(renderEventCard)}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgrammeEvents;
